import React from 'react'
import PropTypes from 'prop-types'

class NewsRoute extends React.Component {

    async componentWillMount() {
        await this.props.history.push('/news/1')
    }

    render() {
        return (
            <div>
            </div>
        )
    }
}

NewsRoute.propTypes = {
    history: PropTypes.object,
}

export default NewsRoute



// WEBPACK FOOTER //
// ./src/views/News/NewsRoute.jsx